import { JOBS_URL } from '@/utils/constants'

const JOB_TASKS = (jobId: string) => `${JOBS_URL}/${jobId}/tasks`
const JOB_TASK_BY_ID = (jobId: string, taskId: string) => `${JOB_TASKS(jobId)}/${taskId}`
const JOB_TASK_CANCEL = (jobId: string, taskId: string) => `${JOB_TASK_BY_ID(jobId, taskId)}/cancel`
const JOB_TASK_SCHEDULE = (jobId: string, taskId: string) =>
  `${JOB_TASK_BY_ID(jobId, taskId)}/schedule`
const JOB_TASK_REPORT_PDF = (jobId: string, taskId: string) =>
  `${JOB_TASK_BY_ID(jobId, taskId)}/report/pdf`

export default {
  JOB_TASKS,
  JOB_TASK_BY_ID,
  JOB_TASK_CANCEL,
  JOB_TASK_SCHEDULE,
  JOB_TASK_REPORT_PDF
}
